import React from "react";
import MainContent from "../../../../widgets/templates/main_content";
import Table from "./table";
import { paths } from "../../../app_modules";
import AdminHeader from "../../../../widgets/templates/admin_header";

function UsersPage(){

    return(
        <MainContent>
            <AdminHeader 
                title="Usuarios" 
                masivPath={paths.user_form} 
                createPath={paths.create_user_request_form} 
            />
            <hr />
            <div style={{ width: '100%' }}>
                <Table />
            </div>
        </MainContent>
    );
}

export default UsersPage;